export default __webpack_public_path__ + "static/media/1.120dffb1.jpg";